import React, { useEffect } from 'react';
import './AboutUsPage.scss';

import About from '../../Component/PagesComponent/Homepage/About/About';
import Brands from '../../Component/PagesComponent/Homepage/Brands/Brands';
import Testimony from '../../Component/PagesComponent/Homepage/Testimony/Testimony';

const AboutUsPage = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (
        <div className="about-us-page">
            <About />
            <Brands />
            <Testimony />
        </div>
    );
};

export default AboutUsPage;